import EventSeriesCard from './event-series-card';
import type { EventSeries } from '../types/EventSeries';

type Props = {
  list: EventSeries[];
};

const EventSeriesList = ({ list }: Props) => (
  <>
    {list.map((eventSeries) => (
      <EventSeriesCard
        key={eventSeries.id}
        eventSeries={eventSeries}
      />
    ))}
  </>
);

export default EventSeriesList;
